var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-white pl-25 pr-25", attrs: { id: "panel-filter" } },
    [
      _c("div", { staticClass: "search-wrapper" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.trim",
              value: _vm.search,
              expression: "search",
              modifiers: { trim: true }
            }
          ],
          attrs: { type: "text", placeholder: "Zoeken in NHN op de kaart..." },
          domProps: { value: _vm.search },
          on: {
            change: function($event) {
              _vm.searchHandler()
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.search = $event.target.value.trim()
            },
            blur: function($event) {
              _vm.$forceUpdate()
            }
          }
        }),
        _vm._v(" "),
        _vm.search.length > 1
          ? _c(
              "button",
              {
                attrs: { id: "btn-reset" },
                on: {
                  click: function($event) {
                    _vm.emitGlobalClickEvent()
                  }
                }
              },
              [_vm._v("Wis")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            attrs: { id: "btn-search" },
            on: {
              click: function($event) {
                _vm.searchHandler()
              }
            }
          },
          [_vm._v("Zoek")]
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c(
          "button",
          {
            staticClass: "btn b-shadow-1",
            on: {
              click: function($event) {
                _vm.emitGlobalClickEvent()
              }
            }
          },
          [_vm._v("Wis alle filters")]
        )
      ]),
      _vm._v(" "),
      _c(
        "panel-filter-group",
        { attrs: { title: "Zoek in gemeenten" } },
        [
          _c("filter-checkbox-group", {
            attrs: {
              group_type: "subregio",
              group: "Alkmaar",
              hasSelectAll: "true"
            }
          }),
          _vm._v(" "),
          _c("filter-checkbox-group", {
            attrs: {
              group_type: "subregio",
              group: "Kop van Noord-Holland",
              hasSelectAll: "true"
            }
          }),
          _vm._v(" "),
          _c("filter-checkbox-group", {
            attrs: {
              group_type: "subregio",
              group: "West-Friesland",
              hasSelectAll: "true"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "panel-filter-group",
        { attrs: { title: "Bekijk sectoren in de regio" } },
        [_c("filter-checkbox-group", { attrs: { group_type: "sector" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "panel-filter-group",
        { attrs: { title: "Wat we doen in de regio" } },
        [
          _c("filter-checkbox-group", {
            attrs: { group_type: "typeactiviteit" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "panel-filter-group",
        { attrs: { title: "Ons netwerk" } },
        [_c("filter-checkbox-group", { attrs: { group_type: "onsnetwerk" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib?{}!./scripts/vue/PanelFilter.vue?vue&type=template&id=0e2b7f98&
// module id = 76
// module chunks = 0